import { render, staticRenderFns } from "./SettingsIndexesAddMarketEditor.vue?vue&type=template&id=2bb0a2be&"
import script from "./SettingsIndexesAddMarketEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexesAddMarketEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports